import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ChatService {


    static sendMessage(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.sendMessage}`;
        return axiosInstance
            .post(api, data)

    }

    static getConversation(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.getConversation}`;
        return axiosInstance
            .get(api, data)

    }

    static getMessage(item) {

        let api = `${API_BASE_URL}${API_PATHS.getMessage}`;
        const params = new URLSearchParams();

        if (item?.conversationId) params.append("conversationId", item.conversationId);
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }
        return axiosInstance
            .get(api, item)

    }

    static getConversationByUser(item) {

        let api = `${API_BASE_URL}${API_PATHS.getConversationByUser}`;
        const params = new URLSearchParams();

        if (item?.userId) params.append("userId", item.userId);
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }
        return axiosInstance
            .get(api, item)

    }



}

export default ChatService;
